module.exports = __webpack_public_path__ + "static/media/Fichier 28.8ebeb4b0.svg";